import { render, staticRenderFns } from "./announcementDetailNew.vue?vue&type=template&id=68a51b4a&scoped=true"
import script from "./announcementDetailNew.vue?vue&type=script&lang=js"
export * from "./announcementDetailNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a51b4a",
  null
  
)

export default component.exports